import type { QBOCategory, QBOLocation, QBOVendor } from '@/services/qbo'

export const QBO_LISTS_CACHE_KEY = 'bookkeeper:qbo-lists-cache'

export interface QboListsCachePayload {
  savedAt: number
  vendors: QBOVendor[]
  locations: QBOLocation[]
  categories: QBOCategory[]
}

export function loadQboListsCache(): QboListsCachePayload | null {
  try {
    const raw = localStorage.getItem(QBO_LISTS_CACHE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as QboListsCachePayload
    if (!parsed?.savedAt) return null
    if (!Array.isArray(parsed.vendors) || !Array.isArray(parsed.locations) || !Array.isArray(parsed.categories)) {
      return null
    }
    return parsed
  } catch {
    localStorage.removeItem(QBO_LISTS_CACHE_KEY)
    return null
  }
}

export function saveQboListsCache(payload: Omit<QboListsCachePayload, 'savedAt'>): void {
  const full: QboListsCachePayload = { ...payload, savedAt: Date.now() }
  localStorage.setItem(QBO_LISTS_CACHE_KEY, JSON.stringify(full))
}

export function clearQboListsCache(): void {
  localStorage.removeItem(QBO_LISTS_CACHE_KEY)
}
